import React from "react";
import ServiceDetail from "./ServiceDetail";
import LogoCollage from "../../Components/Assets/Logo-Collage.jpeg";

function LogoDesign() {
  return (
    <ServiceDetail
      eyebrow="Logo Design"
      title="Logo Design Packages"
      description="Custom logo packages built to give your business a clean, memorable, and professional visual identity."
      ctaText="Request Custom Logo Quote"

      heroImage={LogoCollage}

      packages={[
        {
          name: "Basic Logo",
          subtitle: "Starter identity package",
          price: 65,
          features: [
            "2 custom logo concepts",
            "1 designer",
            "2 revisions",
            "PNG and JPG files",
            "Delivered within 48–72 hours",
          ],
        },
        {
          name: "Startup Logo",
          subtitle: "Best for new businesses",
          price: 95,
          featured: true,
          features: [
            "4 custom logo concepts",
            "3 revisions",
            "Brand color direction",
            "PNG, JPG, and PDF files",
            "Delivered within 48–72 hours",
          ],
        },
        {
          name: "Professional Logo",
          subtitle: "Complete logo identity",
          price: 175,
          features: [
            "6 custom logo concepts",
            "Unlimited revisions",
            "Typography and color direction",
            "SVG, PNG, JPG, and PDF files",
            "Social media profile versions",
          ],
        },
      ]}
      process={[
        {
          title: "Discovery",
          text: "We learn about your brand, audience, style, and goals.",
        },
        {
          title: "Concepts",
          text: "You receive custom logo directions based on your package.",
        },
        {
          title: "Finalize",
          text: "We refine your selected design and deliver final files.",
        },
      ]}
    />
  );
}

export default LogoDesign;